// src/components/DebugMonitor.js
import React, { useState, useEffect } from 'react';

// This component will help debug image upload issues
const DebugMonitor = ({ isActive = false }) => {
  const [logs, setLogs] = useState([]);
  const [isVisible, setIsVisible] = useState(false);

  // Override console.log and other methods to capture them
  useEffect(() => {
    if (!isActive) return;

    const oldLog = console.log;
    const oldError = console.error;
    const oldWarn = console.warn;

    // Add timestamp and store console logs
    console.log = (...args) => {
      oldLog(...args);
      setLogs(prevLogs => [
        ...prevLogs, 
        { type: 'log', content: args, time: new Date().toLocaleTimeString() }
      ].slice(-50)); // Keep only last 50 logs
    };

    console.error = (...args) => {
      oldError(...args);
      setLogs(prevLogs => [
        ...prevLogs, 
        { type: 'error', content: args, time: new Date().toLocaleTimeString() }
      ].slice(-50));
    };

    console.warn = (...args) => {
      oldWarn(...args);
      setLogs(prevLogs => [
        ...prevLogs, 
        { type: 'warn', content: args, time: new Date().toLocaleTimeString() }
      ].slice(-50));
    };

    // Restore original methods when component unmounts
    return () => {
      console.log = oldLog;
      console.error = oldError;
      console.warn = oldWarn;
    };
  }, [isActive]);

  if (!isActive) return null;

  // Format log content for display
  const formatContent = (content) => {
    return content.map(item => {
      if (typeof item === 'string') return item;
      if (item instanceof Error) return item.message;
      try {
        return JSON.stringify(item, null, 2);
      } catch (e) {
        return String(item);
      }
    }).join(' ');
  };

  return (
    <div style={{ position: 'fixed', bottom: '10px', right: '10px', zIndex: 9999 }}>
      <button 
        onClick={() => setIsVisible(!isVisible)} 
        style={{ 
          padding: '5px 10px', 
          backgroundColor: 'var(--primary-color)', 
          color: 'white', 
          border: 'none', 
          borderRadius: '5px' 
        }}
      >
        {isVisible ? 'Hide Debug' : 'Show Debug'}
      </button>
      
      {isVisible && (
        <div 
          style={{ 
            width: '400px', 
            maxHeight: '400px', 
            overflow: 'auto', 
            backgroundColor: 'rgba(0,0,0,0.8)', 
            color: 'white', 
            padding: '10px', 
            borderRadius: '5px',
            marginTop: '5px',
            fontSize: '12px',
            fontFamily: 'monospace'
          }}
        >
          <h4 style={{ margin: '0 0 10px 0' }}>Debug Logs</h4>
          {logs.length === 0 ? (
            <div>No logs yet</div>
          ) : (
            logs.map((log, index) => (
              <div 
                key={index} 
                style={{ 
                  marginBottom: '5px', 
                  color: log.type === 'error' ? '#ff6b6b' : log.type === 'warn' ? '#feca57' : '#1dd1a1',
                  borderBottom: '1px solid rgba(255,255,255,0.1)',
                  paddingBottom: '5px'
                }}
              >
                <span style={{ opacity: 0.7 }}>[{log.time}]</span> {formatContent(log.content)}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default DebugMonitor;